import { getIdToken } from '@/lib/auth';

async function vendorNotifyUrl(): Promise<string | null> {
  const fromEnv = import.meta.env.VITE_VENDOR_NOTIFY_URL;
  if (fromEnv) return fromEnv;
  try {
    const cacheBust = import.meta.env.DEV ? `?t=${Date.now()}` : '';
    const res = await fetch(`/amplify_outputs.json${cacheBust}`, { cache: 'no-store' });
    if (res.ok) {
      const outputs = (await res.json()) as { custom?: { vendorNotifyUrl?: string } };
      return outputs.custom?.vendorNotifyUrl ?? null;
    }
  } catch {
    /* missing outputs */
  }
  return null;
}

/** Ask Google/Bing to crawl an approved vendor profile (Indexing API + IndexNow when configured). */
export async function requestVendorIndexing(vendorId: string): Promise<void> {
  const url = await vendorNotifyUrl();
  const token = await getIdToken();
  if (!url || !token) return;

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ action: 'requestIndexing', vendorId }),
  });
  if (!res.ok) {
    const payload = (await res.json().catch(() => ({}))) as { error?: string };
    console.warn('[seo] requestVendorIndexing failed', payload.error ?? res.status);
  }
}
